import { AbstractArray } from '../abstract/Array.js';
/**
 * @name VecAny
 * @description
 * This manages codec arrays, assuming that the inputs are already of type Codec. Unlike
 * a vector, this can be used to manage array-like structures with variable arguments of
 * any types
 */
export class VecAny extends AbstractArray {
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        // FIXME This is basically an any type, cannot instantiate via createType
        return 'Vec<Codec>';
    }
}
